function isES2015() {
  if (typeof Symbol === 'undefined' || typeof Reflect === 'undefined' || typeof Proxy === 'undefined' || Object.isSealed(Proxy)) return false;

  return true;
}

export default isES2015();



// WEBPACK FOOTER //
// ./src/utils/isES2015.js